import React from 'react'

import { EngWordFullProps } from 'core/interfaces/dictionary-eng-interfaces'
import { WordTranslation, SentenceWithTranslit } from '../../../lib/interfaces'
import ErrorOccurred from '../../errors/error-occurred'
import MainWordBar from './main-word-bar'
import EnglishWordThaiMeanings from './english-word-thai-meanings'

type ErrorType = 'Word Does Not Exist' | 'Server Error'

type Props = {
   errorType?: ErrorType
   engDictionaryWord: EngWordFullProps
   translations: WordTranslation[]
   // Word-level fallback: sentences not yet classified to a sense.
   exampleSentences: SentenceWithTranslit[]
   exampleSentencesByMeaningId: Record<number, SentenceWithTranslit[]>
}

const EngDictionaryPage = (props: Props) => {
   const { errorType, engDictionaryWord } = props
   const { audio } = engDictionaryWord

   if (errorType && errorType === 'Server Error') {
      return <ErrorOccurred />
   }

   const gbAudioFiles = audio.filter((a) => a.name.endsWith('Gb')).map((a) => a.url)
   const usAudioFiles = audio.filter((a) => a.name.endsWith('Us')).map((a) => a.url)

   return (
      <div className="flex justify-center px-[8px] sm:px-[20px] pt-[8px] pb-[40px] bg-pageBg">
         <div className="w-[900px] max-w-full">
            <MainWordBar
               word={engDictionaryWord.word}
               commonnessScore={engDictionaryWord.commonnessScore}
               gbAudioFiles={gbAudioFiles}
               usAudioFiles={usAudioFiles}
               ipaUk={engDictionaryWord.ipaUk}
               thaiPhonetic={engDictionaryWord.thaiPhonetic}
            />
            <EnglishWordThaiMeanings
               engDictionaryWord={props.engDictionaryWord}
               translations={props.translations}
               exampleSentences={props.exampleSentences}
               exampleSentencesByMeaningId={props.exampleSentencesByMeaningId}
            />
         </div>
      </div>
   )
}

export default EngDictionaryPage
